import React from 'react';
import { string } from 'prop-types';
import css from './ShareViaSocialNetworkButtons.css';
import Button from '../Button/Button';
import { IconCopyL } from '../../icons';

const copyLink = shareLink => {
    const documentIsDefined = typeof document !== 'undefined'; // for server-side rendering
    if (documentIsDefined) {
        const elementLink = document.createElement('textarea');
        elementLink.value = shareLink;
        document.body.appendChild(elementLink);
        elementLink.select();
        document.execCommand('copy');
        document.body.removeChild(elementLink);
    }
};

const CopyLinkButton = ({ url, text }) => (
    <Button className={css.shareItem} onClick={() => copyLink(url)}>
        <IconCopyL />
        <span>{text}</span>
    </Button>
);

CopyLinkButton.propTypes = {
    url: string,
};

export default CopyLinkButton;
